module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carTypeScroll"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('div', {
    staticClass: "arrows arrowsLeft",
    on: {
      "click": function($event) {
        return _vm.clickFn('left')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jiantou"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ScrollCont"
  }, [_c('ul', _vm._l((_vm.carTypeDataFn.data), function(item, index) {
    return _c('li', {
      staticClass: "ScrollContLi",
      class: _vm.action === item.index ? 'ScrollContLiShow' : ''
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "arrows arrowsRight",
    on: {
      "click": function($event) {
        return _vm.clickFn('right')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jiantou"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b29f41","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/carTypeScroll/src/carTypeScroll.vue
// module id = 514
// module chunks = 0